import { render, staticRenderFns } from "./marksEntryAll.vue?vue&type=template&id=06c3e632&scoped=true&"
import script from "./marksEntryAll.vue?vue&type=script&lang=js&"
export * from "./marksEntryAll.vue?vue&type=script&lang=js&"
import style0 from "./marksEntryAll.vue?vue&type=style&index=0&id=06c3e632&lang=scss&scoped=true&"
import style1 from "./marksEntryAll.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./marksEntryAll.vue?vue&type=style&index=2&id=06c3e632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c3e632",
  null
  
)

export default component.exports